<template>
  <div class="seeds">
    <div class="seeds-lg">
        <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'"
                   :column="3"  border>
          <el-descriptions-item label="科中文名" prop="sectionChinese">
            {{ infoContent.sectionChinese }}
          </el-descriptions-item>
          <el-descriptions-item label="科拉丁名" prop="sectionLatin"  span="2">
            {{ infoContent.sectionLatin }}
          </el-descriptions-item>
<!--          <el-descriptions-item label="属中文名" prop="belongChinese">-->
<!--            {{ infoContent.belongChinese }}-->
<!--          </el-descriptions-item>-->
<!--          <el-descriptions-item label="属拉丁名" prop="belongLatin" span="2">-->
<!--            {{ infoContent.belongLatin }}-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item label="中文名" prop="growChinese">
            {{ infoContent.growChinese }}
          </el-descriptions-item>
          <el-descriptions-item label="学名" prop="growLatin" span="2">
            {{ infoContent.growLatin }}
          </el-descriptions-item>
          <el-descriptions-item label="资源类型" prop="resourceType">
            {{ infoContent.resourceType }}
          </el-descriptions-item>
          <el-descriptions-item label="采集号" prop="collectNumber" span="2">
            {{ infoContent.collectNumber }}
          </el-descriptions-item>
          <el-descriptions-item label="采集人" prop="collectUser">
            {{ infoContent.collectUser }}
          </el-descriptions-item>
<!--          <el-descriptions-item label="采集时间" prop="collectTime" span="1">-->
<!--            {{ infoContent.collectTime }}-->
<!--          </el-descriptions-item>-->
          <el-descriptions-item label="采集年份" prop="collectYear" span="1">
            {{ infoContent.collectYear }}
          </el-descriptions-item>
          <el-descriptions-item label="省" prop="province">
            {{ infoContent.province }}
          </el-descriptions-item>
          <el-descriptions-item label="地区" prop="area">
            {{ infoContent.area }}
          </el-descriptions-item>
          <el-descriptions-item label="区/县" prop="district">
            {{ infoContent.district }}
          </el-descriptions-item>
          <el-descriptions-item label="单位" prop="sampleUnit">
            {{ infoContent.sampleUnit }}
          </el-descriptions-item>
          <el-descriptions-item label="专题负责人" prop="specialLeader">
            {{ infoContent.specialLeader }}
          </el-descriptions-item>
          <el-descriptions-item label="备注" prop="note">
            {{ infoContent.note }}
          </el-descriptions-item>
          <el-descriptions-item label="发布时间" prop="createTime">
            {{ infoContent.createTime }}
          </el-descriptions-item>
<!--    <el-descriptions-item v-if="infoContent.pictureVideoFileList.length > 0" label="图片展示" span="3"  class="img">-->
<!--      <el-carousel :interval="2000" arrow="always">-->
<!--        <el-carousel-item v-for="item in infoContent.pictureVideoFileList"-->
<!--                          :key="item.id">-->
<!--          <img :src="item.url" alt="">-->
<!--        </el-carousel-item>-->
<!--      </el-carousel>-->
<!--    </el-descriptions-item>-->
  </el-descriptions>
    </div>
    <div class="seeds-sm">
      <el-descriptions class="margin-top" style="text-align: center" :title="this.title + '详情'"
                       :column="3"  border>
        <el-descriptions-item label="科中文名" prop="sectionChinese">
          {{ infoContent.sectionChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="科拉丁名" prop="sectionLatin"  span="2">
          {{ infoContent.sectionLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="中文名" prop="growChinese">
          {{ infoContent.growChinese }}
        </el-descriptions-item>
        <el-descriptions-item label="学名" prop="growLatin" span="2">
          {{ infoContent.growLatin }}
        </el-descriptions-item>
        <el-descriptions-item label="资源类型" prop="resourceType">
          {{ infoContent.resourceType }}
        </el-descriptions-item>
        <el-descriptions-item label="采集号" prop="collectNumber" span="2">
          {{ infoContent.collectNumber }}
        </el-descriptions-item>
        <el-descriptions-item label="采集人" prop="collectUser">
          {{ infoContent.collectUser }}
        </el-descriptions-item>
        <el-descriptions-item label="采集年份" prop="collectYear" span="1">
          {{ infoContent.collectYear }}
        </el-descriptions-item>
        <el-descriptions-item label="省" prop="province">
          {{ infoContent.province }}
        </el-descriptions-item>
        <el-descriptions-item label="地区" prop="area">
          {{ infoContent.area }}
        </el-descriptions-item>
        <el-descriptions-item label="区/县" prop="district">
          {{ infoContent.district }}
        </el-descriptions-item>
        <el-descriptions-item label="单位" prop="sampleUnit">
          {{ infoContent.sampleUnit }}
        </el-descriptions-item>
        <el-descriptions-item label="专题负责人" prop="specialLeader">
          {{ infoContent.specialLeader }}
        </el-descriptions-item>
        <el-descriptions-item label="备注" prop="note">
          {{ infoContent.note }}
        </el-descriptions-item>
        <el-descriptions-item label="发布时间" prop="createTime">
          {{ infoContent.createTime }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
    </div>
</template>

<script>
export default {
  name: "seeds",
  props: {
    infoContent: Object,
    title: String
  }
}
</script>

<style scoped lang="scss">
.seeds {
  .seeds-lg {
    display: block;
  }
  .seeds-sm {
    display: none;
  }
}
::v-deep .el-descriptions__body .el-descriptions__table .el-descriptions-item__cell {
  text-align: center !important;
}
@media screen and (max-width: 1200px) {

}
@media screen and (max-width: 992px) {

}
@media screen and (max-width: 768px) {


}
@media screen and (max-width: 576px) {
  .seeds {
    .seeds-lg {
      display: none;
    }
    .seeds-sm {
      display: block;
      .carousel {
        width: 99%;
        height: 80%;
        .carousel-img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
}
</style>